/*eslint-disable*/
import Api from '../'

class AccountApi {
    static updateAccountBalance(id, params) {
        return Api.axios.put('/account/' + id + '/balance', params)
            .then(response => response.data);
    }

    static updateAccountMinPayment (id, params) {
        return Api.axios.put('/account/' + id + '/min-payment', params)
            .then(response => response.data.account);
    }

    static updateStatus(id, params) {
        return Api.axios.put('/account/' + id + '/status', params)
            .then(response => response.data.account);
    }

    static getSumToPay(id, params) {
        return Api.axios.post('/account/sum-to-pay/' + id, params)
            .then(response => response.data);
    }

    static getSumToPayForTeachers(id, params) {
        return Api.axios.post('/account/sum-to-pay-teachers/' + id, params)
            .then(response => response.data);
    }

    static activateAccount(id) {
        return Api.axios.put('/account/' + id + '/activate')
            .then(response => response.data);
    }

    static updatePaymentNotification(id) {
        return Api.axios.put('/account/payment-notification/' + id);
    }
}

export default AccountApi;
